/*
 * Combo product form (lipsticks / blush / brush / kajal dropdowns).
 *
 * Loaded once by layout/theme.liquid. The init guard short-circuits on
 * non-combo pages and allows a newly rendered Shopify section to initialize.
 */

(function () {
  /* Dropdown open/close functions referenced by inline onclick="" attributes.
     Must be on window scope and available before clicks. */

  window.toggleLipDropdown = function () {
    const list = document.getElementById('lipDropdownList');
    if (!list) return;
    list.style.display = list.style.display === 'block' ? 'none' : 'block';
  };

  window.toggleBlushDropdown = function () {
    const list = document.getElementById('blushDropdownList');
    if (!list) return;
    list.style.display = list.style.display === 'block' ? 'none' : 'block';
  };
  window.selectBlushOption = function (el) {
    const text = document.getElementById('blushSelectedText');
    const input = document.getElementById('blushHiddenInput');
    const list = document.getElementById('blushDropdownList');
    if (text) text.innerText = el.dataset.value;
    if (input) input.value = el.dataset.value;
    if (list) list.style.display = 'none';
  };

  window.toggleBrushDropdown = function () {
    const list = document.getElementById('brushDropdownList');
    if (!list) return;
    list.style.display = list.style.display === 'block' ? 'none' : 'block';
  };
  window.selectBrushOption = function (el) {
    const text = document.getElementById('brushSelectedText');
    const input = document.getElementById('brushHiddenInput');
    const list = document.getElementById('brushDropdownList');
    if (text) text.innerText = el.dataset.value;
    if (input) input.value = el.dataset.value;
    if (list) list.style.display = 'none';
  };

  window.toggleKajalDropdown = function () {
    const list = document.getElementById('kajalDropdownList');
    if (!list) return;
    list.style.display = list.style.display === 'block' ? 'none' : 'block';
  };
  window.selectKajalOption = function (el) {
    const text = document.getElementById('kajalSelectedText');
    const input = document.getElementById('kajalHiddenInput');
    const list = document.getElementById('kajalDropdownList');
    if (text) text.innerText = el.dataset.value;
    if (input) input.value = el.dataset.value;
    if (list) list.style.display = 'none';
  };

  window.validateComboLipstickSelection = function (form) {
    const wrapper = form?.querySelector('.custom-shade-wrapper');
    if (!wrapper || !wrapper.querySelector('.lip-option-item')) return true;

    if (wrapper.querySelectorAll('.lip-option-item.selected').length === 2) return true;
    alert('Please choose at least 2 lipstick shades.');
    return false;
  };

  function init() {
    const wrapper = document.querySelector('.custom-shade-wrapper');
    if (!wrapper || wrapper.dataset.comboFormInitialized === 'true') return;

    const lipSelectedText = document.getElementById('lipSelectedText');
    const lipHiddenInputs = document.getElementById('lipHiddenInputs');
    const addToCartBtn = document.querySelector('.product-form__submit');
    if (!lipSelectedText || !lipHiddenInputs || !addToCartBtn) return;

    wrapper.dataset.comboFormInitialized = 'true';

    let lipSelectQueue = [];

    lipSelectedText.innerText = 'Please select shade';

    function validateLipsticks() {
      const selected = document.querySelectorAll('.lip-option-item.selected');
      if (selected.length !== 2) {
        addToCartBtn.setAttribute('disabled', true);
        addToCartBtn.classList.add('disable_shade');
      } else {
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.classList.remove('disable_shade');
      }
    }

    function updateLipSelectedDisplay() {
      const selected = document.querySelectorAll('.lip-option-item.selected');
      const values = [...selected].map((el) => el.dataset.value);
      lipSelectedText.innerText = values.length ? values.join(', ') : 'Please select shade';
      lipHiddenInputs.innerHTML = '';
      values.forEach((v) => {
        lipHiddenInputs.innerHTML += `<input type="hidden" name="properties[Lipsticks Shade][]" value="${v}">`;
      });
    }

    window.toggleLipOption = function (el) {
      const value = el.dataset.value;
      if (el.classList.contains('selected')) {
        el.classList.remove('selected');
        lipSelectQueue = lipSelectQueue.filter((v) => v !== value);
      } else {
        lipSelectQueue.push(value);
        if (lipSelectQueue.length > 2) {
          const removedValue = lipSelectQueue.shift();
          const removeEl = document.querySelector(`.lip-option-item[data-value="${removedValue}"]`);
          if (removeEl) removeEl.classList.remove('selected');
        }
        el.classList.add('selected');
      }
      updateLipSelectedDisplay();
      validateLipsticks();
    };

    document.addEventListener('click', function (event) {
      const btn = event.target.closest('.product-form__submit');
      if (!btn) return;
      if (!window.validateComboLipstickSelection(btn.closest('form'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
    });

    const blushText = document.getElementById('blushSelectedText');
    const blushInput = document.getElementById('blushHiddenInput');
    if (blushText) blushText.innerText = 'Please select shade';
    if (blushInput) blushInput.value = '';

    const brushItems = document.querySelectorAll('#brushDropdownList .cs-option');
    if (brushItems.length > 0) {
      const firstBrush = brushItems[0].dataset.value;
      const brushText = document.getElementById('brushSelectedText');
      const brushInput = document.getElementById('brushHiddenInput');
      if (brushText) brushText.innerText = firstBrush;
      if (brushInput) brushInput.value = firstBrush;
    }

    const kajalItems = document.querySelectorAll('#kajalDropdownList .cs-option');
    if (kajalItems.length > 0) {
      const firstKajal = kajalItems[0].dataset.value;
      const kajalText = document.getElementById('kajalSelectedText');
      const kajalInput = document.getElementById('kajalHiddenInput');
      if (kajalText) kajalText.innerText = firstKajal;
      if (kajalInput) kajalInput.value = firstKajal;
    }

    validateLipsticks();
  }

  /* Close dropdowns when clicking outside. Safe to run on any page; the
     querySelector inside is null-tolerant. */
  document.addEventListener('click', function (event) {
    const dropdowns = [
      { list: 'lipDropdownList', toggle: 'lipSelectedText' },
      { list: 'blushDropdownList', toggle: 'blushSelectedText' },
      { list: 'brushDropdownList', toggle: 'brushSelectedText' },
      { list: 'kajalDropdownList', toggle: 'kajalSelectedText' },
    ];
    dropdowns.forEach(function (d) {
      const listEl = document.getElementById(d.list);
      const toggleParent = document.getElementById(d.toggle)?.parentElement;
      if (!listEl || !toggleParent) return;
      if (!listEl.contains(event.target) && !toggleParent.contains(event.target)) {
        listEl.style.display = 'none';
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
